import React from "react";

interface TransactionTypeProps {
  type: string;
}

export const TransactionType = ({ type }: TransactionTypeProps) => {
  if (type === "SALE") {
    return (
      <span className=" inline-block w-fit rounded-full bg-indigo-100 px-2 py-1 text-xs font-medium text-indigo-800 mb-2">
        Venta
      </span>
    );
  }
  if (type === "REFUND") {
    return (
      <span className="inline-block w-fit rounded-full bg-purple-100 px-2 py-1 text-xs font-medium text-purple-800">
        Reembolso
      </span>
    );
  }
  if (type === "REVERSAL") {
    return (
      <span className="inline-block w-fit rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-800">
        Reverso
      </span>
    );
  }
  if (type === "ERROR") {
    return (
      <span className="inline-block w-fit rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-800">
        Error
      </span>
    );
  }
  if (type === "DENIED") {
    return (
      <span className="inline-block w-fit rounded-full bg-orange-100 px-2 py-1 text-xs font-medium text-orange-800">
        Denegado
      </span>
    );
  }

  return (
    <span className="inline-block w-fit rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-800">
      Sin Tipo
    </span>
  );
};
